import { render, staticRenderFns } from "./discount_allowed.vue?vue&type=template&id=fb79c88a"
import script from "./discount_allowed.vue?vue&type=script&lang=js"
export * from "./discount_allowed.vue?vue&type=script&lang=js"
import style0 from "./discount_allowed.vue?vue&type=style&index=0&id=fb79c88a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports